module.exports = __webpack_public_path__ + "b5e8db933dd6b937d283acbd2e7ad2fb.pdf";